import { jsPDF } from "jspdf";

export default (episode) => ({
  exportPdf(e) {
    e.preventDefault();
    const doc = jsPDF();
    doc.setFontSize(12);

    const transcript = episode.transcript?.transcript;

    if (!episode.transcript || transcript == null) {
      alert("Export failed. Empty transcript.");
    } else {
      const pageHeight = doc.internal.pageSize.height;

      // splitTextToSize returns an array with the text splitted into lines, the second argument is the size
      const wrappedText = doc.splitTextToSize(transcript, 180);

      // Default export is A4 paper, portrait, using millimeters for units
      let iterations = 1;
      const margin = 15; // Top and bottom margin in mm
      const defaultYSpace = 5; // Default space between lines in mm

      wrappedText.forEach((line) => {
        let posY = margin + defaultYSpace * iterations++;
        if (posY > pageHeight - margin) {
          doc.addPage();
          iterations = 1;
          posY = margin + defaultYSpace * iterations++;
        }
        doc.text(line, 15, posY);
      });

      doc.save("transcript-" + episode.post_title + ".pdf");
    }
  },
});
